<template>
  <v-card style="overflow-y: unset">
    <v-card-text class="px-0 py-0">
      <slot></slot>
    </v-card-text>
    <v-card-actions>
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="auto" class="tw:flexrow-1.5">
          <base-button type="alternative" @click="$emit('cancel')" :disabled="isLoading">
            {{ $i18n.t('button.cancel') }}
          </base-button>
          <base-button @click="$emit('save', setLoading)" :loading="isLoading" :disabled="isSaveDisabled">
            {{ $i18n.t('button.save') }}
          </base-button>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'InputCard',
  props: {
    isSaveDisabled: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
  }),
  methods: {
    setLoading(value) {
      this.isLoading = value;
    },
  },
};
</script>

<style lang="scss" scoped></style>
